import React, { useEffect, useState } from "react"
import { useParams, useNavigate, Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { AddOutlined, Publish } from "@material-ui/icons"
import {
   getStorage,
   ref,
   uploadBytesResumable,
   getDownloadURL,
} from "firebase/storage"
import app from "../../firebase"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
import SimpleLineChart from "../../components/SimpleLineChart/SimpleLineChart"
import Checkbox from "../../components/Checkbox/Checkbox"
// Data
import { userRequest } from "../../requestMethods"
import { updateProduct } from "../../redux/apiCalls"
// Styles
import {
   Container,
   Wrapper,
   Main,
   TitleWrapper,
   Title,
   StyledButton,
   Top,
   TopLeft,
   TopRight,
   Bottom,
   InfoTop,
   InfoBottom,
   ButtonContainer,
   ButtonWrapper,
   Message,
} from "./Product.styles"
import {
   Image,
   Name,
   ItemKey,
   ItemValue,
   InfoItem,
   UpdateTitle,
   UpdateLeft,
   UpdateItem,
   StyledLabel,
   StyledInput,
   UpdateRight,
} from "./Product.styles"
import {
   StyledForm,
   StyledSelect,
   StyledOption,
   StyledTextArea,
   NestedObjects,
   NestedObject,
   Upload,
   UpdateImage,
   UploadIcon,
} from "./Product.styles"
import { AddVariation } from "./Product.styles"

const Product = () => {
   const { productId } = useParams()
   const dispatch = useDispatch()
   const navigate = useNavigate()
   const [errorMessage, setErrorMessage] = useState("")

   const product = useSelector((state) =>
      state.product.products.find((product) => product._id === productId)
   )
   const eansArray = useSelector((state) =>
      state.product.products.map((product) =>
         product.variations.map((variation) => variation.ean)
      )
   )
   let eans = []
   for (let i = 0; i < eansArray.length; i++) {
      eans = [...eans, ...eansArray[i]]
   }
   const [maxEan, setMaxEan] = useState(Math.max(...eans))

   const [productStats, setProductStats] = useState([])
   const [productInputs, setProductInputs] = useState({
      desc: [
         { language: "en", text: "" },
         { language: "fr", text: "" },
      ],
   })
   const [variationsInputs, setVariationsInputs] = useState([
      {
         ean: maxEan,
         detailedColor: [
            { language: "en", text: "" },
            { language: "fr", text: "" },
         ],
      },
   ])
   const [pricesInputs, setPricesInputs] = useState([
      { userType: "optician" },
      { userType: "distributor" },
      { userType: "public" },
   ])

   useEffect(() => {
      const getStats = async () => {
         try {
            const res = await userRequest.get(
               `orders/product/month?product=${productId}&sort=asc`
            )
            res.data.map((item) =>
               setProductStats((prev) => [
                  ...prev,
                  { name: item._id, Sales: item.total },
               ])
            )
         } catch (err) {
            setProductStats([])
            console.log(err)
         }
      }
      getStats()

      if (typeof product === "object" && product !== null) {
         setProductInputs({ ...product })
         let variationsToUpdate = []
         let pricesToUpdate = []
         for (let i = 0; i < product.variations.length; i++) {
            variationsToUpdate.push({ ...product.variations[i] })
         }
         for (let i = 0; i < product.prices.length; i++) {
            pricesToUpdate.push({ ...product.prices[i] })
         }
         setVariationsInputs(variationsToUpdate)
         setPricesInputs(pricesToUpdate)
      }
   }, [productId, product])

   const getStock = () => {
      let sum = 0
      product.variations.forEach((item) => {
         sum += item.inventory
      })
      return sum
   }

   const [latestChecked, setLatestChecked] = useState(product.latest)
   const latestCheckChange = () => {
      setProductInputs((prev) => {
         return { ...prev, latest: !latestChecked }
      })
      setLatestChecked((current) => !current)
   }

   const [outCollectionChecked, setOutCollectionChecked] = useState(
      product.outOfCollection
   )
   const outCollectionChange = () => {
      setProductInputs((prev) => {
         return { ...prev, outOfCollection: !outCollectionChecked }
      })
      setOutCollectionChecked((current) => !current)
   }

   const addVariation = () => {
      setVariationsInputs((current) => [
         ...current,
         {
            ean: maxEan + 1,
            detailedColor: [
               { language: "en", text: "" },
               { language: "fr", text: "" },
            ],
         },
      ])
      setMaxEan((current) => current + 1)
   }

   const removeVariation = (i) => {
      setVariationsInputs((current) => [
         ...current.slice(0, i),
         ...current.slice(i + 1),
      ])
   }

   const handleChange = (e) => {
      setProductInputs((prev) => {
         return { ...prev, [e.target.name]: e.target.value }
      })
   }

   const handleCategories = (e) => {
      let categories = []
      const options = e.target.options
      for (let i = 0; i < options.length; i++) {
         options[i].selected && categories.push(options[i].value)
      }
      setProductInputs((prev) => {
         return { ...prev, categories: categories }
      })
   }

   const handleDesc = (e, lang) => {
      e.preventDefault()
      let desc = []
      for (let i = 0; i < productInputs.desc.length; i++) {
         desc.push({ ...productInputs.desc[i] })
      }
      desc.find((item) => item.language === lang).text = e.target.value
      setProductInputs((prev) => {
         return { ...prev, desc: desc }
      })
   }

   const handleVariation = (e) => {
      const index = parseInt(e.target.name.split("_")[0])
      const name = e.target.name.split("_")[1]
      const value = e.target.value
      let variationsValues = variationsInputs
      variationsValues[index][name] = value
      setVariationsInputs([...variationsValues])
   }

   const handleDetailedColor = (e, index, lang) => {
      e.preventDefault()
      let variationsValues = [...variationsInputs]
      let variationsColors = []
      for (let i = 0; i < variationsValues[index].detailedColor.length; i++) {
         variationsColors.push({
            ...variationsValues[index].detailedColor[i],
         })
      }
      variationsColors.find((item) => item.language === lang).text =
         e.target.value
      variationsValues[index]["detailedColor"] = variationsColors
      setVariationsInputs([...variationsValues])
   }

   const handleImages = (e, colorTheme) => {
      e.preventDefault()
      const storage = getStorage(app)
      let storageRef

      const index = parseInt(e.target.name.split("_")[0])
      let variationsValues = variationsInputs
      if (colorTheme === "dark") {
         variationsValues[index]["imagesDark"] = []
      } else {
         variationsValues[index]["imagesLight"] = []
      }

      let files = Array.from(e.target.files)
      let fileName = ""
      const productFolder =
         productInputs.title?.replace(/\s+/g, "_").toLowerCase() || "default"

      for (let i = 0; i < files.length; i++) {
         if (files[i].name.includes("mp4")) {
            fileName =
               variationsValues[index].code + "_v" + i + "_" + colorTheme
         } else {
            fileName = variationsValues[index].code + "_" + i + "_" + colorTheme
         }
         storageRef = ref(storage, `Products/${productFolder}/${fileName}`)
         const uploadTask = uploadBytesResumable(storageRef, files[i])

         uploadTask.on(
            "state_changed",
            (snapshot) => {
               const progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100
               console.log("Upload is " + progress + "% done")
               switch (snapshot.state) {
                  case "paused":
                     console.log("Upload is paused")
                     break
                  case "running":
                     console.log("Upload is running")
                     break
                  default:
               }
            },
            (error) => {
               console.log(error)
            },
            () => {
               getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                  console.log("File available at", downloadURL)
                  if (colorTheme === "dark") {
                     variationsValues[index]["imagesDark"].push(downloadURL)
                     variationsValues[index]["imagesDark"].sort()
                  } else {
                     variationsValues[index]["imagesLight"].push(downloadURL)
                     variationsValues[index]["imagesLight"].sort()
                  }
               })
            }
         )
      }
      setVariationsInputs([...variationsValues])
   }

   const deleteImages = (e, index, colorTheme) => {
      e.preventDefault()
      let variationsValues = variationsInputs

      if (colorTheme === "dark") {
         variationsValues[index]["imagesDark"] = []
      } else {
         variationsValues[index]["imagesLight"] = []
      }
      setVariationsInputs([...variationsValues])
   }

   const handlePrice = (e) => {
      const index = parseInt(e.target.name.split("_")[0])
      const name = e.target.name.split("_")[1]
      const value = e.target.value
      let pricesValues = pricesInputs
      pricesValues[index][name] = value
      setPricesInputs([...pricesValues])
   }

   const handleSubmit = async (e) => {
      e.preventDefault()
      const productUpdated = {
         ...productInputs,
         variations: variationsInputs,
         prices: pricesInputs,
      }
      const res = await updateProduct(productId, productUpdated, dispatch)
      if (res === "success") {
         navigate("/products")
      } else {
         setErrorMessage(res)
      }
   }

   return (
      <>
         <Topbar />
         <Container>
            <Wrapper>
               <Sidebar />
            </Wrapper>
            <Main>
               <TitleWrapper>
                  <Title>Edit Product</Title>
                  <Link to="/newProduct">
                     <StyledButton>Create</StyledButton>
                  </Link>
               </TitleWrapper>
               <Top>
                  <TopLeft>
                     <SimpleLineChart
                        data={productStats}
                        dataKey="Sales"
                        title="Sales Performance"
                     />
                  </TopLeft>
                  <TopRight>
                     <InfoTop>
                        <Name>{product.title}</Name>
                        <Image src={product.variations[0].imagesLight[0]} />
                     </InfoTop>
                     <InfoBottom>
                        <InfoItem>
                           <ItemKey>Id:</ItemKey>
                           <ItemValue>{product._id}</ItemValue>
                        </InfoItem>
                        <InfoItem>
                           <ItemKey>Sales:</ItemKey>
                           <ItemValue>824</ItemValue>
                        </InfoItem>
                        <InfoItem>
                           <ItemKey>Stock:</ItemKey>
                           <ItemValue>{getStock()}</ItemValue>
                        </InfoItem>
                        <InfoItem>
                           <ItemKey>Created at:</ItemKey>
                           <ItemValue>{product.createdAt}</ItemValue>
                        </InfoItem>
                        <InfoItem>
                           <ItemKey>Updated at:</ItemKey>
                           <ItemValue>{product.updatedAt}</ItemValue>
                        </InfoItem>
                     </InfoBottom>
                  </TopRight>
               </Top>
               <Bottom>
                  <UpdateTitle>Edit</UpdateTitle>
                  <StyledForm>
                     <UpdateLeft>
                        <UpdateItem>
                           <StyledLabel>Product name</StyledLabel>
                           <StyledInput
                              type="text"
                              name="title"
                              defaultValue={product.title}
                              onChange={handleChange}
                           />
                        </UpdateItem>
                        <UpdateItem>
                           <StyledLabel>Categories</StyledLabel>
                           <StyledSelect
                              name="category"
                              id="category"
                              multiple
                              defaultValue={product.categories}
                              onChange={handleCategories}
                           >
                              <StyledOption value="optical">
                                 Optical
                              </StyledOption>
                              <StyledOption value="sun">Sun</StyledOption>
                              <StyledOption value="accessory">
                                 Accessory
                              </StyledOption>
                           </StyledSelect>
                        </UpdateItem>
                        <UpdateItem>
                           <StyledLabel>Collection season</StyledLabel>
                           <StyledSelect
                              name="collectionSeason"
                              id="collectionSeason"
                              defaultValue={product.collectionSeason}
                              onChange={handleChange}
                           >
                              <StyledOption value=""></StyledOption>
                              <StyledOption value="s25">
                                 Fall Winter 2025
                              </StyledOption>
                              <StyledOption value="m26">
                                 Spring Summer 2026
                              </StyledOption>
                           </StyledSelect>
                        </UpdateItem>
                        <UpdateItem>
                           <StyledLabel>Gender</StyledLabel>
                           <StyledSelect
                              name="gender"
                              id="gender"
                              defaultValue={product.gender}
                              onChange={handleChange}
                           >
                              <StyledOption value=""></StyledOption>
                              <StyledOption value="f">Female</StyledOption>
                              <StyledOption value="m">Male</StyledOption>
                              <StyledOption value="u">Unisex</StyledOption>
                           </StyledSelect>
                        </UpdateItem>
                        <UpdateItem>
                           <StyledLabel>Material</StyledLabel>
                           <StyledSelect
                              name="material"
                              id="material"
                              defaultValue={product.material}
                              onChange={handleChange}
                           >
                              <StyledOption value=""></StyledOption>
                              <StyledOption value="acetate">
                                 Acetate
                              </StyledOption>
                              <StyledOption value="metal">Metal</StyledOption>
                              <StyledOption value="combined">
                                 Combined
                              </StyledOption>
                           </StyledSelect>
                        </UpdateItem>
                        <UpdateItem>
                           <StyledLabel>Shape</StyledLabel>
                           <StyledSelect
                              name="shape"
                              id="shape"
                              defaultValue={product.shape}
                              onChange={handleChange}
                           >
                              <StyledOption value=""></StyledOption>
                              <StyledOption value="square">
                                 Squared
                              </StyledOption>
                              <StyledOption value="panto">Panto</StyledOption>
                              <StyledOption value="butterfly">
                                 Butterfly
                              </StyledOption>
                              <StyledOption value="round">Round</StyledOption>
                              <StyledOption value="oval">Oval</StyledOption>
                              <StyledOption value="aviator">
                                 Aviator
                              </StyledOption>
                              <StyledOption value="hexagon">
                                 Hexagonal
                              </StyledOption>
                           </StyledSelect>
                        </UpdateItem>
                     </UpdateLeft>
                     <UpdateLeft>
                        <UpdateItem>
                           <StyledLabel>Lens width</StyledLabel>
                           <StyledInput
                              type="number"
                              name="lensWidth"
                              defaultValue={product.lensWidth}
                              onChange={handleChange}
                           />
                        </UpdateItem>
                        <UpdateItem>
                           <StyledLabel>Lens height</StyledLabel>
                           <StyledInput
                              type="number"
                              name="lensHeight"
                              defaultValue={product.lensHeight}
                              onChange={handleChange}
                           />
                        </UpdateItem>
                        <UpdateItem>
                           <StyledLabel>Nose</StyledLabel>
                           <StyledInput
                              type="number"
                              name="nose"
                              defaultValue={product.nose}
                              onChange={handleChange}
                           />
                        </UpdateItem>
                        <UpdateItem>
                           <StyledLabel>Temple length</StyledLabel>
                           <StyledInput
                              type="number"
                              name="templeLength"
                              defaultValue={product.templeLength}
                              onChange={handleChange}
                           />
                        </UpdateItem>
                        <UpdateItem>
                           <StyledLabel>Total width</StyledLabel>
                           <StyledInput
                              type="number"
                              name="totalWidth"
                              defaultValue={product.totalWidth}
                              onChange={handleChange}
                           />
                        </UpdateItem>
                        <UpdateItem>
                           <StyledLabel>Size</StyledLabel>
                           <StyledSelect
                              name="size"
                              id="size"
                              defaultValue={product.size}
                              onChange={handleChange}
                           >
                              <StyledOption value="1">S</StyledOption>
                              <StyledOption value="2">M</StyledOption>
                              <StyledOption value="3">L</StyledOption>
                              <StyledOption value="4">XL</StyledOption>
                           </StyledSelect>
                        </UpdateItem>
                     </UpdateLeft>
                     <UpdateRight>
                        <UpdateItem>
                           <StyledLabel>Description EN</StyledLabel>
                           <StyledTextArea
                              defaultValue={
                                 product.desc.find(
                                    (item) => item.language === "en"
                                 ).text
                              }
                              onChange={(e) => handleDesc(e, "en")}
                           />
                        </UpdateItem>
                        <UpdateItem>
                           <StyledLabel>Description FR</StyledLabel>
                           <StyledTextArea
                              defaultValue={
                                 product.desc.find(
                                    (item) => item.language === "fr"
                                 ).text
                              }
                              onChange={(e) => handleDesc(e, "fr")}
                           />
                        </UpdateItem>
                        <UpdateItem>
                           <StyledLabel>
                              <Checkbox
                                 checked={latestChecked}
                                 onChange={latestCheckChange}
                              />
                              Latest
                           </StyledLabel>
                        </UpdateItem>
                        <UpdateItem>
                           <StyledLabel>
                              <Checkbox
                                 checked={outCollectionChecked}
                                 onChange={outCollectionChange}
                              />
                              Out of collection
                           </StyledLabel>
                        </UpdateItem>
                        <UpdateItem>
                           <StyledLabel>Ranking</StyledLabel>
                           <StyledInput
                              type="number"
                              name="ranking"
                              defaultValue={product.ranking}
                              onChange={handleChange}
                           />
                        </UpdateItem>
                     </UpdateRight>
                  </StyledForm>
               </Bottom>
               <NestedObjects>
                  {variationsInputs?.map((item, index) => (
                     <NestedObject key={item._id}>
                        <InfoItem>
                           <ItemKey>Id:</ItemKey>
                           <ItemValue>{item._id}</ItemValue>
                        </InfoItem>
                        <StyledForm>
                           <UpdateLeft>
                              <UpdateItem>
                                 <StyledLabel>Variation code</StyledLabel>
                                 <StyledInput
                                    type="text"
                                    name={`${index}_code`}
                                    defaultValue={item.code}
                                    onChange={handleVariation}
                                 />
                              </UpdateItem>
                              <UpdateItem>
                                 <StyledLabel>Main Color</StyledLabel>
                                 <StyledSelect
                                    name={`${index}_mainColor`}
                                    id="mainColor"
                                    defaultValue={item.mainColor}
                                    onChange={handleVariation}
                                 >
                                    <StyledOption value=""></StyledOption>
                                    <StyledOption value="black">
                                       Noir
                                    </StyledOption>
                                    <StyledOption value="crystal">
                                       Cristal
                                    </StyledOption>
                                    <StyledOption value="goldyellow">
                                       Or jaune
                                    </StyledOption>
                                    <StyledOption value="goldpink">
                                       Or rose
                                    </StyledOption>
                                    <StyledOption value="silver">
                                       Argent
                                    </StyledOption>
                                    <StyledOption value="turtle">
                                       Écaille
                                    </StyledOption>
                                    <StyledOption value="blue">
                                       Bleu
                                    </StyledOption>
                                    <StyledOption value="red">
                                       Rouge
                                    </StyledOption>
                                    <StyledOption value="green">
                                       Vert
                                    </StyledOption>
                                    <StyledOption value="grey">
                                       Gris
                                    </StyledOption>
                                    <StyledOption value="orange">
                                       Orange
                                    </StyledOption>
                                    <StyledOption value="yellow">
                                       Jaune
                                    </StyledOption>
                                    <StyledOption value="purple">
                                       Violet
                                    </StyledOption>
                                    <StyledOption value="pink">
                                       Rose
                                    </StyledOption>
                                    <StyledOption value="brown">
                                       Marron
                                    </StyledOption>
                                    <StyledOption value="panther">
                                       Panthère
                                    </StyledOption>
                                    <StyledOption value="ruthenium">
                                       Ruthénium
                                    </StyledOption>
                                    <StyledOption value="white">
                                       Blanc
                                    </StyledOption>
                                 </StyledSelect>
                              </UpdateItem>
                              <UpdateItem>
                                 <StyledLabel>Second Color</StyledLabel>
                                 <StyledSelect
                                    name={`${index}_secondColor`}
                                    id="secondColor"
                                    defaultValue={item.secondColor}
                                    onChange={handleVariation}
                                 >
                                    <StyledOption value=""></StyledOption>
                                    <StyledOption value="black">
                                       Noir
                                    </StyledOption>
                                    <StyledOption value="crystal">
                                       Cristal
                                    </StyledOption>
                                    <StyledOption value="goldyellow">
                                       Or jaune
                                    </StyledOption>
                                    <StyledOption value="goldpink">
                                       Or rose
                                    </StyledOption>
                                    <StyledOption value="silver">
                                       Argent
                                    </StyledOption>
                                    <StyledOption value="turtle">
                                       Écaille
                                    </StyledOption>
                                    <StyledOption value="blue">
                                       Bleu
                                    </StyledOption>
                                    <StyledOption value="red">
                                       Rouge
                                    </StyledOption>
                                    <StyledOption value="green">
                                       Vert
                                    </StyledOption>
                                    <StyledOption value="grey">
                                       Gris
                                    </StyledOption>
                                    <StyledOption value="orange">
                                       Orange
                                    </StyledOption>
                                    <StyledOption value="yellow">
                                       Jaune
                                    </StyledOption>
                                    <StyledOption value="purple">
                                       Violet
                                    </StyledOption>
                                    <StyledOption value="pink">
                                       Rose
                                    </StyledOption>
                                    <StyledOption value="brown">
                                       Marron
                                    </StyledOption>
                                    <StyledOption value="panther">
                                       Panthère
                                    </StyledOption>
                                    <StyledOption value="ruthenium">
                                       Ruthénium
                                    </StyledOption>
                                    <StyledOption value="white">
                                       Blanc
                                    </StyledOption>
                                 </StyledSelect>
                              </UpdateItem>
                              <UpdateItem>
                                 <StyledLabel>Detailed Color EN</StyledLabel>
                                 <StyledInput
                                    type="text"
                                    defaultValue={
                                       item.detailedColor?.find(
                                          (color) => color.language === "en"
                                       )?.text
                                    }
                                    onChange={(e) =>
                                       handleDetailedColor(e, index, "en")
                                    }
                                 />
                              </UpdateItem>
                              <UpdateItem>
                                 <StyledLabel>Detailed Color FR</StyledLabel>
                                 <StyledInput
                                    type="text"
                                    defaultValue={
                                       item.detailedColor?.find(
                                          (color) => color.language === "fr"
                                       )?.text
                                    }
                                    onChange={(e) =>
                                       handleDetailedColor(e, index, "fr")
                                    }
                                 />
                              </UpdateItem>
                              <UpdateItem>
                                 <StyledLabel>EAN13</StyledLabel>
                                 <StyledInput
                                    type="text"
                                    name={`${index}_ean`}
                                    value={item.ean || maxEan}
                                    onChange={handleVariation}
                                 />
                              </UpdateItem>
                              <UpdateItem>
                                 <StyledLabel>Inventory</StyledLabel>
                                 <StyledInput
                                    type="number"
                                    name={`${index}_inventory`}
                                    defaultValue={item.inventory}
                                    onChange={handleVariation}
                                 />
                              </UpdateItem>
                              <UpdateItem>
                                 <StyledLabel>Collection season</StyledLabel>
                                 <StyledSelect
                                    name={`${index}_collectionSeason`}
                                    id="collectionSeason"
                                    defaultValue={item.collectionSeason}
                                    onChange={handleVariation}
                                 >
                                    <StyledOption value=""></StyledOption>
                                    <StyledOption value="s25">
                                       Fall Winter 2025
                                    </StyledOption>
                                    <StyledOption value="m26">
                                       Spring Summer 2026
                                    </StyledOption>
                                 </StyledSelect>
                              </UpdateItem>
                              <UpdateItem>
                                 <StyledLabel>Images for Dark Mode</StyledLabel>
                                 <Upload>
                                    {item.imagesDark?.map((img, index) => (
                                       <UpdateImage
                                          key={img}
                                          src={item.imagesDark[index]}
                                       />
                                    ))}
                                    <StyledLabel
                                       htmlFor={`${index}_dark_files`}
                                    >
                                       <UploadIcon>
                                          <Publish />
                                       </UploadIcon>
                                    </StyledLabel>
                                    <StyledInput
                                       type="file"
                                       id={`${index}_dark_files`}
                                       name={`${index}_dark_files`}
                                       style={{ display: "none" }}
                                       multiple
                                       onChange={(e) => handleImages(e, "dark")}
                                    />
                                 </Upload>
                              </UpdateItem>
                              <StyledButton
                                 onClick={(e) => deleteImages(e, index, "dark")}
                              >
                                 Remove dark images
                              </StyledButton>
                              <UpdateItem>
                                 <StyledLabel>
                                    Images for Light Mode
                                 </StyledLabel>
                                 <Upload>
                                    {item.imagesLight?.map((img, index) => (
                                       <UpdateImage
                                          key={img}
                                          src={item.imagesLight[index]}
                                       />
                                    ))}
                                    <StyledLabel
                                       htmlFor={`${index}_light_files`}
                                    >
                                       <UploadIcon>
                                          <Publish />
                                       </UploadIcon>
                                    </StyledLabel>
                                    <StyledInput
                                       type="file"
                                       id={`${index}_light_files`}
                                       name={`${index}_light_files`}
                                       style={{ display: "none" }}
                                       multiple
                                       onChange={(e) =>
                                          handleImages(e, "light")
                                       }
                                    />
                                 </Upload>
                              </UpdateItem>
                              <StyledButton
                                 onClick={(e) =>
                                    deleteImages(e, index, "light")
                                 }
                              >
                                 Remove light images
                              </StyledButton>
                           </UpdateLeft>
                        </StyledForm>
                        <StyledButton onClick={() => removeVariation(index)}>
                           Delete variation
                        </StyledButton>
                     </NestedObject>
                  ))}
                  <AddVariation onClick={() => addVariation()}>
                     <AddOutlined fontSize="large" />
                  </AddVariation>
               </NestedObjects>
               <NestedObjects>
                  {pricesInputs?.map((item, index) => (
                     <NestedObject type="price" key={item._id}>
                        <InfoItem>
                           <ItemKey>Id:</ItemKey>
                           <ItemValue>{item._id}</ItemValue>
                        </InfoItem>
                        <InfoItem>
                           <ItemKey>User Type:</ItemKey>
                           <ItemValue>{item.userType}</ItemValue>
                        </InfoItem>
                        <StyledForm>
                           <UpdateLeft>
                              <UpdateItem>
                                 <StyledLabel>Currency</StyledLabel>
                                 <StyledSelect
                                    name={`${index}_currency`}
                                    id="currency"
                                    defaultValue={item.currency}
                                    onChange={handlePrice}
                                 >
                                    <StyledOption value=""></StyledOption>
                                    <StyledOption value="eur">EUR</StyledOption>
                                    <StyledOption value="usd">USD</StyledOption>
                                 </StyledSelect>
                              </UpdateItem>
                              <UpdateItem>
                                 <StyledLabel>Beginning Date</StyledLabel>
                                 <StyledInput
                                    type="date"
                                    name={`${index}_beginningDate`}
                                    defaultValue={
                                       item.beginningDate?.split("T")[0]
                                    }
                                    onChange={handlePrice}
                                 />
                              </UpdateItem>
                              <UpdateItem>
                                 <StyledLabel>Ending Date</StyledLabel>
                                 <StyledInput
                                    type="date"
                                    name={`${index}_endingDate`}
                                    defaultValue={
                                       item.endingDate?.split("T")[0]
                                    }
                                    onChange={handlePrice}
                                 />
                              </UpdateItem>
                              <UpdateItem>
                                 <StyledLabel>Price</StyledLabel>
                                 <StyledInput
                                    type="number"
                                    name={`${index}_price`}
                                    defaultValue={item.price}
                                    onChange={handlePrice}
                                 />
                              </UpdateItem>
                           </UpdateLeft>
                        </StyledForm>
                     </NestedObject>
                  ))}
               </NestedObjects>
               <ButtonContainer>
                  <ButtonWrapper>
                     <StyledButton onClick={handleSubmit}>Update</StyledButton>
                     <Message>{errorMessage}</Message>
                  </ButtonWrapper>
               </ButtonContainer>
            </Main>
         </Container>
      </>
   )
}

export default Product
